import debounce from 'lodash/debounce';
import LazyLoad from 'vanilla-lazyload';
import Navigation from './modules/navigation';
import Slick from './modules/slick';

jQuery(document).on('ready', function() {
    let lazyLoadInstance = new LazyLoad();
    let navigationInstance = new Navigation();
    let slickInstance = new Slick();
    let updateLazyLoad = debounce(lazyLoadInstance.update.bind(lazyLoadInstance), 100);

    document.querySelectorAll('.callout-hover-container .callout-card').forEach(function(el) {
        let content = el.querySelector('.callout-card-content');
        let contentContainer = el.querySelector('.callout-card-content-container');
        contentContainer.style.maxHeight = 'none';
        let totalHeight = content.getBoundingClientRect().height;
        contentContainer.style.maxHeight = '0';
        el.style.setProperty('--callout-max-height', totalHeight + 'px');
    });

    jQuery(window).on('acf/loaded/callout-hover', function() {
        updateLazyLoad();
    });

    jQuery(window).on('acf/loaded/checkerboard', function() {
        updateLazyLoad();
    });

    jQuery(window).on('acf/loaded/centered-slider', function() {
        slickInstance.initPortfolioSlick();
        updateLazyLoad();
    });

    jQuery(window).on('acf/loaded/callout-people', function() {
        updateLazyLoad();
    });

    jQuery(window).on('acf/loaded/callout-landscape', function() {
        updateLazyLoad();
    });
});

jQuery(window).on('resize', debounce(function() {
    document.querySelectorAll('.callout-hover-container .callout-card').forEach(function(el) {
        let content = el.querySelector('.callout-card-content');
        let contentContainer = el.querySelector('.callout-card-content-container');
        contentContainer.style.maxHeight = 'none';
        let totalHeight = content.getBoundingClientRect().height;
        contentContainer.style.maxHeight = '0';
        el.style.setProperty('--callout-max-height', totalHeight + 'px');
    });
}, 100));

